import React from "react";
import { Modal, Button, Card, Alert } from "react-bootstrap";

function JudgementModal({
  responseCaseStatus,
  errorString,
  submitError,
  show,
  benchName,
  handleClose,
}) {
  // If there's an error in the API response, display the error message
  if (submitError) {
    return (
      <Modal show={show} onHide={handleClose}>
        <Modal.Header onClick={handleClose}>
          <Modal.Title>Error</Modal.Title>
          <Button className="btn-secondary">X</Button>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="danger">
            {responseCaseStatus?.error ||
              "An error occurred. Please try again."}
          </Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  // If there's an error message in the API response, display the error message
  if (errorString !== "") {
    return (
      <Modal show={show} onHide={handleClose}>
        <Modal.Header onClick={handleClose}>
          <Button className="btn-secondary">X</Button>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="danger">{errorString}</Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  // If there's no data, do not render anything
  if (!responseCaseStatus || !responseCaseStatus.data) return null;

  const renderCaseDetails = (caseDetail) => (
    <Card className="mb-3" key={caseDetail.case_no}>
      <Card.Body>
        <Card.Title className="rct-secondry-heading">
          {caseDetail.case_title}
        </Card.Title>
        <Card.Text>
          <div className="titlesec">
            <h4 className="httxt">Case Status</h4>
          </div>
          <table className="table table-striped table-bordered table-hover case-table">
            <tbody>
              <tr>
                <td>
                  <span>Case No:</span>
                </td>
                <td> {caseDetail.case_no}</td>
              </tr>
              <tr>
                <td>
                  <span>Status:</span>{" "}
                </td>
                <td>{caseDetail.c_status}</td>
              </tr>
              <tr>
                <td>
                  <span>Filing No:</span>{" "}
                </td>
                <td>{caseDetail.filing_no}</td>
              </tr>
              <tr>
                <td>
                  <span>Date of Filing:</span>
                </td>
                <td> {caseDetail.date_of_filing}</td>
              </tr>
              <tr>
                <td>
                  <span>Case Registered Date:</span>{" "}
                </td>
                <td>{caseDetail.case_registered_date}</td>
              </tr>
              <tr>
                <td>
                  <span>Case Title :</span>
                </td>
                <td>{caseDetail.case_title}</td>
              </tr>
              <tr>
                <td>
                  <span>IA Filing/Case No.:</span>{" "}
                </td>
                <td>
                  {caseDetail.ia_filing_no} {caseDetail.ia_case_no}
                </td>
              </tr>
              <tr>
                <td>
                  <span>Status:</span>
                </td>
                <td>{caseDetail.c_status}</td>
              </tr>
            </tbody>
          </table>
          <div className="titlesec">
            <h4 className="httxt">Applicants' Details</h4>
          </div>
          <table className="table table-striped table-bordered table-hover case-table">
            <tbody>
              <tr>
                <td>
                  <span>Name:</span>
                </td>
                <td>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: `${caseDetail.pet_names}`,
                    }}
                  ></span>{" "}
                </td>
              </tr>
              <tr>
                <td>
                  <span>Advocate:</span>
                </td>
                <td> {caseDetail.pet_adv_name}</td>
              </tr>
            </tbody>
          </table>

          <div className="titlesec">
            <h4 className="httxt">Respondents' Details</h4>
          </div>
          <table className="table table-striped table-bordered table-hover case-table">
            <tbody>
              <tr>
                <td>
                  <span>Name:</span>
                </td>
                <td> {caseDetail.res_names}</td>
              </tr>
              <tr>
                <td>
                  <span>Advocate:</span>
                </td>
                <td> {caseDetail.res_adv_name}</td>
              </tr>
            </tbody>
          </table>
        </Card.Text>
      </Card.Body>
    </Card>
  );

  const renderProceedings = (proceeding, index) => {
    // Only render rows where order_type is "J"
    if (proceeding.order_type !== "J") {
      return (
        <tr key={index}>
          <td>{index + 1}</td>
          <td>{benchName} BENCH</td>
          <td>{proceeding.court_no}</td>
          <td>{proceeding.listing_date}</td>
          <td>{proceeding.listing_purpose}</td>
          <td>{proceeding.next_listing_date}</td>
          <td>{proceeding.today_action}</td>
          {/* <td>{proceeding.c_status}</td> */}
          <td>
            {proceeding.file_name ? (
              <a
                href={`${process.env.REACT_APP_API_FILE_URL}/displayOrder/${proceeding.filing_no}/${proceeding.hash_filename}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                View Order
              </a>
            ) : (
              "N/A"
            )}
          </td>
          <td>{proceeding.last_update}</td>
        </tr>
      );
    }
    return null; // If order_type is not "J", do not render anything
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header onClick={handleClose}>
        <Modal.Title>Judgement Details</Modal.Title>
        <Button className="btn-secondary">X</Button>
      </Modal.Header>
      <Modal.Body>
        {responseCaseStatus.data.map(renderCaseDetails)}

        {responseCaseStatus.allProceeding &&
          responseCaseStatus.allProceeding.length > 0 && (
            <>
              <div className="titlesec">
                <h4 className="httxt">Case Proceeding Details :</h4>
              </div>

              <table className="table table-bordered common-table modal-custom-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Bench Name</th>
                    <th>Court No</th>
                    <th>Hearing Date</th>
                    <th>Purpose</th>
                    <th>Next Listing/ Disposal Date</th>
                    <th>Next Listing Purpose</th>
                    {/* <th>Status</th> */}
                    <th>Orders</th>
                    <th>Updated on</th>
                  </tr>
                </thead>
                <tbody>
                  {responseCaseStatus.allProceeding.map(renderProceedings)}
                </tbody>
              </table>
            </>
          )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default JudgementModal;
